module.exports = __webpack_public_path__ + "img/avatar.ae6456e8.png";